export default {
  title: {
    id: 'services_mobile_plan_offers_title_up_to',
    defaultMessage:
      'Up to {price, html} immediate discount with a {partner} plan',
  },
  keepYourPhoneNumberTitle: {
    id: 'services_mobile_plan_offers_keep_your_phone_number_title',
    defaultMessage: 'How does it work?',
  },
  keepYourPhoneNumberContent: {
    id: 'services_mobile_plan_offers_keep_your_phone_number_content',
    defaultMessage:
      'If you want to keep your phone number, {partner} will take care of everything to change the contract with your current provider.',
  },
}
